module.exports = __webpack_public_path__ + "static/img/04.c242990.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daolan/04.jpg
// module id = u3u0
// module chunks = 1